import { render, staticRenderFns } from "./user-files-sick.vue?vue&type=template&id=66fa707e&"
import script from "./user-files-sick.vue?vue&type=script&lang=js&"
export * from "./user-files-sick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports